import { createFileRoute } from '@tanstack/react-router';

import { buildBreadcrumbSchema, buildSeoHead, buildWebPageSchema, jsonLdScript, ROUTE_META } from '@src/corelib/seo';

export const Route = createFileRoute('/services/implementation')({
  head: () => ({
    ...buildSeoHead({ path: '/services/implementation', ...ROUTE_META['/services/implementation'] }),
    scripts: [
      jsonLdScript(buildBreadcrumbSchema([{ name: 'Home', path: '/' }, { name: 'Implementation', path: '/services/implementation' }])),
      jsonLdScript(buildWebPageSchema({ path: '/services/implementation', ...ROUTE_META['/services/implementation'] })),
    ],
  }),
});
